export const DAVEY_TIMBERTRAP_KEY = '1BAWFX8-65D4KFB-QE8R3JR-1J1TB09';
export const DAVEY_TIMBERTRAP_URL = `https://timbertrap.davey.com`;

export const DAVEY_LOG_ROCKET_ID_QA = 'jkzsks/qa-fehhk';
export const DAVEY_LOG_ROCKET_ID_STAGING = 'jkzsks/staging-onbri';
export const DAVEY_LOG_ROCKET_ID_PROD = 'jkzsks/prod-cjnxe';

/**@deprecated We do not need to hard-code expected deployed URLs. This can be deleted once ECC is gone */
export const DAVEY_ENV_PROD_URL = `https://time.davey.com`;
/**@deprecated We do not need to hard-code expected deployed URLs. This can be deleted once ECC is gone */
export const DAVEY_ENV_QA_URL = `https://timeq.davey.com`;
/**@deprecated We do not need to hard-code expected deployed URLs. This can be deleted once ECC is gone */
export const DAVEY_ENV_STAGING_URL = `https://times.davey.com`;
export const DAVEY_ENV_DEV_URL = `http://localhost:3000`;
